import React from "react";

export const TriggersIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M0.999747 12.0035C0.999747 11.4719 1.43075 11.0409 1.96243 11.0409H11.1974L7.25581 7.09929C6.87754 6.72102 6.87993 6.10699 7.26112 5.73167C7.63815 5.36045 8.24402 5.3628 8.61816 5.73694L13.8589 10.9777C14.4255 11.5442 14.4255 12.4628 13.8589 13.0294L8.61816 18.2701C8.24403 18.6443 7.63815 18.6466 7.26112 18.2754C6.87993 17.9001 6.87754 17.2861 7.25581 16.9078L11.1974 12.9662H1.96243C1.43075 12.9662 0.999747 12.5352 0.999747 12.0035Z"
      fill="black"
    />
    <path
      d="M17.989 7.46947C17.5909 7.07135 17.5898 6.42618 17.9867 6.02676L19.1294 4.8765C19.5308 4.47253 20.1846 4.4734 20.5848 4.87843C20.9808 5.27916 20.979 5.92447 20.5806 6.32287L19.4341 7.46944C19.0351 7.86852 18.3881 7.86853 17.989 7.46947ZM19.3335 12.0033C19.3335 11.4359 19.7934 10.976 20.3608 10.976H21.9727C22.5401 10.976 23 11.4359 23 12.0033C23 12.5706 22.5401 13.0306 21.9727 13.0306H20.3608C19.7934 13.0306 19.3335 12.5706 19.3335 12.0033ZM17.989 17.972C17.5906 17.5736 17.5887 16.9282 17.9847 16.5274C18.3851 16.1223 19.0389 16.1215 19.4403 16.5255L20.583 17.6759C20.9797 18.0753 20.9786 18.7204 20.5806 19.1184C20.1816 19.5174 19.5346 19.5175 19.1356 19.1185L17.989 17.972Z"
      fill="black"
    />
  </svg>
);
